import styled, { css } from 'styled-components';
import Close from '@carvana/icons/Close';
import TooltipPosition from './TooltipPosition';

const ARROW_OFFSET = 10;
const ARROW_OFFSET_MOBILE = 60;

const leftArrow = css`
  left: ${ARROW_OFFSET_MOBILE}px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    left: ${ARROW_OFFSET}px;
  }
`;

const rightArrow = css`
  right: ${ARROW_OFFSET_MOBILE}px;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    right: ${ARROW_OFFSET}px;
  }
`;

const downArrow = css`
  bottom: -7px;
  border-top: 8px solid ${(p: any) => p.theme.carvana.blue.dark};
  ${({ arrowPosition }: any) => arrowPosition === 'left' && leftArrow} ${({ arrowPosition }: any) =>
    arrowPosition === 'right' && rightArrow};
`;

const upArrow = css`
  top: -7px;
  border-bottom: 8px solid ${(p: any) => p.theme.carvana.blue.dark};
  ${({ arrowPosition }: any) => arrowPosition === 'left' && leftArrow} ${({ arrowPosition }: any) =>
    arrowPosition === 'right' && rightArrow};
`;

export const OuterWrapper = styled.div`
  position: absolute;
  width: ${({ contentWidth }: any) => (contentWidth !== null && `${contentWidth}px`) || 'auto'};
  ${TooltipPosition};
  max-width: 255px;
`;

export const InnerWrapper = styled.div`
  color: ${(p: any) => p.theme.carvana.white.primary};
  padding: 10px;
  position: relative;
  z-index: 3;
  background: ${(p: any) => p.theme.carvana.blue.dark};
  border-radius: 3px;

  &::after {
    content: '';
    position: absolute;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    ${({ direction }: any) => (direction === 'up' ? upArrow : downArrow)};
  }

  &::before {
    content: '';
    position: absolute;
    padding-bottom: 20px;
    height: 100%;
    width: 23px;
    background: transparent;
    top: 15px;
    right: 6px;
    z-index: 1;
  }
`;

export const CloseIconWrapper = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 40px;
  width: 45px;
  background: transparent;
  z-index: 4;
`;

export const CloseIcon = styled(Close)`
  color: ${(p: any) => p.theme.carvana.white.primary};
  position: absolute !important;
  top: 3px;
  right: 10px;
  cursor: pointer;
  display: block !important;
  z-index: 2;

  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    display: none !important;
  }
`;
